import "./styles/quasar.sass";
import iconSet from "quasar/icon-set/fontawesome-v5.js";
import lang from "quasar/lang/da.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {},
  lang: lang,
  iconSet: iconSet,
};
